import React, { PureComponent } from 'react';
import withWidth from 'material-ui/utils/withWidth';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import routes from '../../../routes';
import { CURRENT_MUI_THEME } from '../../../config';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import actions from '../../../actions';
import { bindActionCreators } from 'redux';
import LoadingWidget from '../../widgets/LoadingWidget/LoadingWidget';
import { isAuthenticated } from '../../../utils/session-util';

class App extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: isAuthenticated()
    };
  }

  componentDidMount() {
    this.props.actions.getLoginItems();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.appStore.loading !== this.props.appStore.loading ||
      prevProps.appStore.fetchedLoginItems !==
        this.props.appStore.fetchedLoginItems
    ) {
      this.setState({
        loading: this.props.appStore.loading
      });
    }
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={CURRENT_MUI_THEME}>
        {this.state.loading ? (
          <LoadingWidget />
        ) : (
          <Router>
            <Switch>{routes}</Switch>
          </Router>
        )}
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(App));
